
/*
    Display of an individual Lane Assignment record,
    split into media queries for different screen sizes
*/

import React from "react";
import Media from "react-media";

import DataItem from "../Components/DataItem";

export default class LaneAssignmentData extends React.Component {

    /*
        day: "Holiday"
        destSign: "316 Sg WILDWOOD EXP CAPE MAY GLOUCESTER OUTLETS   "
        direction: "O"
        endTime: "9:29 PM"
        facilityName: "WALTER RAND TRANSPORTATION CENTER"
        lane: "1"
        lineNumber: "316 "
        startTime: "6:00 AM"
        timePoint: "WRTGATE1"
        towards: "Cape May"
    */

    render() {

        const {data} = this.props;

        return (
            <div className="data" style={{
                display: "flex",
                flexDirection: "column",
                padding: "8px"
            }}>
                <Media query="(max-width: 811px)">
                    <>    
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        marginBottom: "4px"
                    }}>    
                        <div style={{
                            display: "flex",
                            flexDirection: "row",
                            marginRight: "4px"
                        }}>
                            <span style={{marginRight: "4px"}}>Destination: </span>
                            <div style={{backgroundColor: "white", 
                            padding: "0px 4px"}}>
                                <DataItem val={data.destSign} />
                            </div>
                        </div>
                        <div style={{
                            display: "flex",
                            flexDirection: "row"
                        }}>
                            <span style={{marginRight: "4px"}}>Location: </span>
                            <DataItem val={data.facilityName} />
                        </div>
                    </div>        
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr 2fr",
                        justifyItems: "flex-start"
                    }}>
                        <div>
                            Day: <DataItem val={data.day} />
                        </div>
                        <div>
                            Direction: <DataItem val={data.direction} />
                        </div>
                        <div>
                            Start: <DataItem val={data.startTime} />
                        </div>
                        <div>
                            End: <DataItem val={data.endTime} />
                        </div>
                        <div>
                            Route: <DataItem val={data.lineNumber} />
                        </div>
                        <div>
                            Lane: <DataItem val={data.lane} />
                        </div>
                        <div>
                            Towards: <DataItem val={data.towards} />
                        </div>
                        <div>
                            Timepoint: <DataItem val={data.timePoint} />
                        </div>
                    </div>
                    </>
                </Media>

                <Media query="(min-width: 812px)">
                    <>
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "2fr 2fr 1fr",
                        justifyItems: "flex-start",
                        marginBottom: "8px"
                    }}>
                        <div style={{backgroundColor: "white", padding: "0px 2px"}}>
                            <DataItem val={data.destSign} />
                        </div>
                        <div>
                            Location: <DataItem val={data.facilityName} />
                        </div>
                        <div>
                            Timepoint: <DataItem val={data.timePoint} />
                        </div>
                    </div>
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "2fr 1fr 2fr 2fr 1fr 2fr",
                        justifyItems: "flex-start"
                    }}>
                        <div>
                            Route: <DataItem val={data.lineNumber} />
                        </div>
                        <div>
                            Lane: <DataItem val={data.lane} />
                        </div>
                        <div>
                            Towards: <DataItem val={data.towards} />
                        </div>
                        <div>
                            Day: <DataItem val={data.day} />
                        </div>
                        <div>
                            Direction: <DataItem val={data.direction} />
                        </div>
                        <div>
                            Times: <DataItem val={`${data.startTime} - ${data.endTime}`} />
                        </div>
                    </div>
                    </>
                </Media>
            </div>
        );
    }
}